module.exports = __webpack_public_path__ + "static/media/ic-category-cam-off.73169625.svg";